import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { LogoMark } from '@/components/generals/logo'

interface CmsImageProps {
    src?: string | null
    alt?: string | null
    className?: string
    priority?: boolean
}

// Renders an image whose address comes from the CMS. When the field is empty it shows a
// calm branded panel instead of a broken image, so a new model never breaks the layout.
export const CmsImage: FC<CmsImageProps> = ({
    src,
    alt,
    className,
    priority = false
}): ReactNode => {
    if (!src) {
        return (
            <div
                role='img'
                aria-label={alt || 'Photo coming soon'}
                className={cn('flex size-full flex-col items-center justify-center gap-3 bg-secondary text-muted-foreground', className)}
            >
                <LogoMark className='size-12 opacity-60' />

                <span className='text-xs font-semibold tracking-[0.18em] uppercase opacity-80'>
                    Photo coming soon
                </span>
            </div>
        )
    }

    return (
        // eslint-disable-next-line @next/next/no-img-element
        <img
            src={src}
            alt={alt ?? ''}
            loading={priority ? 'eager' : 'lazy'}
            fetchPriority={priority ? 'high' : undefined}
            decoding='async'
            className={cn('size-full object-cover', className)}
        />
    )
}
